import { CurrencySchema } from '@eigtech/currency';
import { z } from 'zod';
export const LineItemTypeSchema = z.enum(['salesLineItem', 'subtotalLineItem', 'taxLineItem']);
export const LineItemTypeEnum = LineItemTypeSchema.enum;
export const ItemSchema = z.object({ label: z.string().optional(), id: z.string() });
export const LineItemSchema = z.object({
    amount: CurrencySchema,
    type: LineItemTypeSchema,
    description: z.string().optional(),
    detail: z.unknown().optional(),
});
export const SalesLineItemSchema = LineItemSchema.extend(z.object({
    type: z.literal(LineItemTypeEnum.salesLineItem),
    detail: z
        .object({
        item: ItemSchema.optional(),
        unitPrice: CurrencySchema.optional(),
        qty: z.number().optional(),
    })
        .optional(),
}).shape);
export const SubtotalLineItemSchema = LineItemSchema.extend(z.object({
    type: z.literal(LineItemTypeEnum.subtotalLineItem),
    detail: z.object({
        item: ItemSchema.optional(),
        lines: LineItemSchema.array(),
    }),
}).shape);
export const TaxLineItemSchema = LineItemSchema.extend(z.object({
    type: z.literal(LineItemTypeEnum.taxLineItem),
    detail: z.object({
        lines: LineItemSchema.array(),
        taxRate: z.number(),
    }),
}).shape);
